import { Link } from "react-router-dom";
import { ArrowUpRight, MapPin } from "lucide-react";

export const DestinationCard = ({ d, className = "" }) => (
  <Link
    to={`/destinations/${d.slug}`}
    className={`group relative block rounded-[28px] overflow-hidden bg-navy shadow-[0_18px_40px_-18px_rgba(6,27,50,.6)] ${className}`}
    data-testid={`destination-card-${d.slug}`}
  >
    {d.image ? (
      <img src={d.image} alt={`${d.name} vacation scenery`} loading="lazy" className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
    ) : (
      <div className="absolute inset-0 ocean-gradient" />
    )}
    <div className="absolute inset-0 bg-gradient-to-t from-navy via-navy/30 to-transparent" />
    <div className="absolute top-4 left-4 flex items-center gap-1 rounded-full bg-white/90 backdrop-blur px-3 py-1 text-xs font-bold text-navy">
      <MapPin className="w-3.5 h-3.5 text-tpink" /> {d.region}
    </div>
    <div className="absolute bottom-0 left-0 right-0 p-5">
      <h3 className="font-brush text-white text-[42px] leading-none text-shadow-hero">{d.name}</h3>
      <p className="text-white/80 text-sm mt-1 line-clamp-1">{d.subtitle}</p>
      <span className="mt-4 inline-flex items-center gap-1.5 rounded-full bg-sun text-navy font-bold text-sm px-4 py-2.5 transition-transform group-hover:-translate-y-0.5" data-testid={`destination-card-shop-${d.slug}`}>
        Shop Collection <ArrowUpRight className="w-4 h-4 transition-transform group-hover:rotate-45" />
      </span>
    </div>
  </Link>
);
